import React, {useState, useMemo} from "react";
import AllCategoriesContext from "./AllCategoriesContext";

const NAVBAR_CATEGORIES_CACHE_KEY = "inproveda_navbar_categories_v1";

const getCachedCategories = () => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const cachedCategories = JSON.parse(
      window.localStorage.getItem(NAVBAR_CATEGORIES_CACHE_KEY) || "[]"
    );
    return Array.isArray(cachedCategories) ? cachedCategories : [];
  } catch (ex) {
    window.localStorage.removeItem(NAVBAR_CATEGORIES_CACHE_KEY);
    return [];
  }
};

const AllCategoriesState = (props) => {
  const [state, setState] = useState(getCachedCategories);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );
  // console.log("all Categories in state:", state);
  return (
    <AllCategoriesContext.Provider value={value}>
      {props.children}
    </AllCategoriesContext.Provider>
  );
};

export default AllCategoriesState;
